<wvr-wysiwyg-wrapper #animationRoot class="wvr-components wvr-wysiwyg">
  <editor
    id="{{htmlId}}"
    [init]="config"
    [outputFormat]="outputFormat"
    [initialValue]="initialValue"
    [(ngModel)]="content">
  </editor>
</wvr-wysiwyg-wrapper>
